import { CreditCard } from 'lucide-react'

/**
 * Inline amber badge used wherever we surface a missing Stripe link — either a
 * missing customer record on a member or a missing subscription on a pet. Kept
 * deliberately generic ("Stripe not linked") because in both cases the practical
 * meaning is the same: we don't have the Stripe-side record we'd need to act on.
 */
export function StripeNotLinkedBadge() {
  return (
    <span className="inline-flex items-center gap-1 text-sm font-semibold text-destructive-fg">
      <CreditCard className="size-3 shrink-0" />
      Stripe not linked
    </span>
  )
}
